import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationError, NavigationStart, Router } from '@angular/router';
import { BuildConfigService, ErrorService } from '@common/util-foundation';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ao-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ao-care.com';
  private subscriptions = new Subscription();

  popStateNavigation$ = this.router.events.pipe(
    filter(
      (allEvents) =>
        !!(allEvents instanceof NavigationStart) &&
        allEvents.navigationTrigger === 'popstate'
    )
  );

  navigationError$ = this.router.events.pipe(
    filter((allEvents) => !!(allEvents instanceof NavigationError))
  );

  constructor(
    private buildConfig: BuildConfigService,
    private errorService: ErrorService,
    private router: Router
  ) {
    this.subscriptions.add(
      this.navigationError$.subscribe(() => {
        this.errorService.handleError();
      })
    );
  }

  ngOnInit(): void {
    this.router.navigateByUrl(this.buildConfig.config.applianceDetailsPage);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
